import { ETAB_ROUTES } from "@etab/config";
import { LoadingManager } from "@core/managers/loading.manager";
import { NotificationsManager } from "@core/managers/notifications.manager";
import { META_HTML_TITLE, RECRUITMENT_TYPES } from "@core/constants";
import { ACTION_EXTRA_GET_BY_ID, ACTION_EXTRA_GET_SKILLS_BY_ID, ACTION_RECRUITMENTS_SET_SELECTED_EXTRA } from "@etab/stores/types";
import { useRecruitmentsStore } from "@etab/stores/recruitments";
import { useExtraStore } from "@etab/stores/extra";
import PermanentCandidates from "./PermanentCandidates.root.vue";
import Profile from "./Profile.page.vue";

export default function () {
  return [
    {
      path: ETAB_ROUTES.dashboard.recruitment.permanent.candidate.root.path,
      name: ETAB_ROUTES.dashboard.recruitment.permanent.candidate.root.name,
      meta: { [META_HTML_TITLE]: "ETAB.PAGES.EXTRA.@TITLE" },
      redirect: { name: ETAB_ROUTES.dashboard.recruitment.permanent.candidate.profile.name },
      component: PermanentCandidates,
      async beforeEnter(to, from, next) {
        const recruitmentsStore = useRecruitmentsStore();
        const extraStore = useExtraStore();
        try {
          LoadingManager.show();
          const demandId = to.params.demandId;
          const candidateId = to.params.candidateId;
          const type = RECRUITMENT_TYPES.PERMANENT.label;
          // select the extra for future reference
          recruitmentsStore[ACTION_RECRUITMENTS_SET_SELECTED_EXTRA](candidateId);
          // get the extra informations
          await extraStore[ACTION_EXTRA_GET_BY_ID]({
            extraId: candidateId,
            demandId,
            type,
          });
          await extraStore[ACTION_EXTRA_GET_SKILLS_BY_ID]({ candidateId });

          next();
        } catch (error) {
          const message = (error && error.message) || "ERRORS.@SOMETHING_WENT_WRONG";
          NotificationsManager.error({ message });
          LoadingManager.hide();
        }
      },
      children: [
        {
          path: ETAB_ROUTES.dashboard.recruitment.permanent.candidate.profile.path,
          name: ETAB_ROUTES.dashboard.recruitment.permanent.candidate.profile.name,
          component: Profile,
        },
      ],
    },
  ];
}
